// Regional User Agreement
import {Regions} from "../shared/enum";
import {AccountRua} from "../shared/model";
import {BaseComponent, Message} from 'iui-iconectiv-lib';

export class AccountRegistrationBase extends BaseComponent  {
    companyName = '';
    spid = '';
    firstName = '';
    lastName = '';
    email = '';
    phone = '';
    address1 = '';
    address2 = '';
    city = '';
    state = '';
    zipCode = '';
    country = '';
    npacUserType = '';
    otherServices = '';
    recaptchaResponse = '';
}

export class AccountRegistration extends AccountRegistrationBase {
    ruaList: AccountRua[] = []; // for 7 NPAC regions
    otherServicesArray: string[] = [];

    // UI working fields
    selectedRegions: string[] = [];
    now: Date = null;
    private valid: boolean;

    constructor() {
        super();
        this.now = new Date();
        Regions.regions.forEach((region) => {
            this.ruaList.push(new AccountRua(region.label));
        });
    }

    isRuaListValid(): boolean {
        let isValid = this.selectedRegions.length > 0;

        if (isValid) {
            this.ruaList.forEach((rua) => {

                if (this.isRegionSelected(rua.region)) {
                    if (rua.contractNumber !== '' && !(rua.contractNumber.indexOf('_',0) > -1)) {
                         rua.isValidContractNumber = true;
                    } else {
                        rua.isValidContractNumber = false;
                    }
                    if (rua.expirationDate !== null && rua.expirationDate > this.now) {
                         rua.isValidExpirationDate = true;
                    } else {
                        rua.isValidExpirationDate = false;
                    }

                    isValid = isValid && rua.isValidAccountRua;
                }
            });
        }
        return isValid;
    }

    // is NPAC Region selected
    isRegionSelected(region: string): boolean {
        return this.selectedRegions.indexOf(region) > -1;
    }

    // set the attirbute of the Region RUA Choose File button
    btnChooseRuaFile(region: string): string {
        return this.isRegionSelected(region) ? 'btn btn-default' : 'btn btn-disabled';
    }

    processUploadedRuaFile(index: number, files) {
        // console.log(files);

        this.ruaList[index].ruaUserFileName = files[0]['name'];
        this.ruaList[index].ruaUserFileSize = files[0]['size'];
        this.ruaList[index].ruaUserFileType = files[0]['type'];

        // const fileSuffix = this.ruaList[index].ruaUserFileName.split('.').pop();

        (0 < this.ruaList[index].ruaUserFileSize && this.ruaList[index].ruaUserFileSize < 500000)
            ? this.ruaList[index].isValidFileSize = true
            : this.ruaList[index].isValidFileSize = false;

           

        ('application/pdf' === this.ruaList[index].ruaUserFileType)
            ? this.ruaList[index].isValidFileType = true
            : this.ruaList[index].isValidFileType = false;

        const reader = new FileReader();
        reader.onload = () => {
            const dataUri = reader.result as string;
            const comma = dataUri.indexOf(',');

            this.ruaList[index].attachmemtContent = dataUri.substring(comma + 1);

        };

        reader.readAsDataURL(files[0]);
    }
}

